import {Component, Input, OnInit} from '@angular/core';
import {FormModel} from '../../../../common/components/form/models';
import {TypeDemandes} from '../type-demandes.enum';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';

/**
 * Affichage comptage et du statut associé
 */
@Component({
  selector: 'app-bloc-response-status',
  templateUrl: './bloc-response-status.component.html',
  styleUrls: ['./bloc-response-status.component.scss']
})
export class BlocResponseStatusComponent implements OnInit {
  @Input() form: FormModel;
  @Input() state: TypeDemandes;
  cntState = 0;
  constructor(public formSvc: FormulaireService) { }

  ngOnInit(): void {
    this.cntState = this.formSvc.calculateCountResponseByState(this.form.responses_count, this.state);
  }
}
